/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Group18IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Group18Icon(props: Group18IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 14 16"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M11.484 0H.328A.33.33 0 0 0 0 .328v12.633a1.477 1.477 0 0 0 2.953 0v-.82h8.86V.328a.33.33 0 0 0-.33-.328zM8.86 9.188H2.953a.328.328 0 0 1 0-.657H8.86a.328.328 0 0 1 0 .656zm0-2.626H2.953a.328.328 0 0 1 0-.656H8.86a.328.328 0 0 1 0 .657zm0-2.625H2.953a.328.328 0 0 1 0-.656H8.86a.328.328 0 0 1 0 .656"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M3.61 12.797v.164c0 1.176-.793 2.133-1.97 2.133h10.173a1.64 1.64 0 0 0 1.64-1.64v-.657z"
        }
      ></path>
    </svg>
  );
}

export default Group18Icon;
/* prettier-ignore-end */
